export enum SELECTED_EMAIL_TYPE {
  SpecificAddress = 1,
  AttributeValue = 2,
}
